import React from 'react';
import DataMetrics from '../dataMetrics';
import { FiPhoneCall, FiMapPin, FiHome } from 'react-icons/fi';

const Links = ({ phone, title, placeId, website }) => {
  const mapLink = `https://www.google.com/maps/search/?api=1&query=${title}&query_place_id=${placeId}`
  return (
    <DataMetrics>
      <ul>
        <li>
          <a
            href={`tel:${phone}`}
          >
          <FiPhoneCall />
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href={mapLink}
            rel="noopener noreferrer"
          >
            <FiMapPin />
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href={website}
            rel="noopener noreferrer"
          >
            <FiHome />
          </a>
        </li>
      </ul>
    </DataMetrics>
  )
}
export default Links;